import React, { createContext, useContext, useMemo } from 'react'

import { useAuthInfo } from '@sweetauth/core'

import { useActiveOrgId } from '@/hooks/organization/useActiveOrgId'

import type { BookmarkCheck } from '@/types/bookmark/Bookmark'

import { createBookmarkCheckLoader } from '@/services/bookmark-check-loader'
import DataLoader from '@/vendor/dataloader'

type LoaderContextType = DataLoader<string, BookmarkCheck> | null | undefined

const LoaderContext = createContext<LoaderContextType>(undefined)

interface BookmarkCheckLoaderProviderProps {
  children: React.ReactNode
}

export const BookmarkCheckLoaderProvider: React.FC<
  BookmarkCheckLoaderProviderProps
> = ({ children }) => {
  const { accessToken } = useAuthInfo()
  const { activeOrgId } = useActiveOrgId()

  const loader = useMemo(() => {
    return accessToken && activeOrgId
      ? createBookmarkCheckLoader(activeOrgId, accessToken)
      : null
  }, [accessToken, activeOrgId])

  return (
    <LoaderContext.Provider value={loader}>{children}</LoaderContext.Provider>
  )
}

export const useBookmarkCheckLoader = () => {
  const context = useContext(LoaderContext)

  if (context === undefined) {
    throw new Error(
      'useBookmarkCheckLoader must be used within a BookmarkCheckLoaderProvider',
    )
  }

  return context
}
